import styles from './Error.module.css'
import Button from '../components/Button'
import { ReactComponent as ErrorIcon } from '../assets/images/icons/ic-error.svg'

const Error = () => <main className={styles.container}>
    <section className={styles.error} aria-labelledby="error-title">
        <span className={styles.icon} aria-hidden="true"><ErrorIcon /></span>
        <span className={styles.eyebrow}>Qualcosa è andato storto</span>
        <h1 id="error-title">Non riusciamo a mostrare questa pagina</h1>
        <p>Si è verificato un problema. Puoi riprovare ad accedere oppure contattare il supporto per ricevere assistenza.</p>
        <div className={styles.actions}>
            <Button onClick={() => { localStorage.clear(); window.location.href = '/login' }}>Torna all’accesso</Button>
            <a className={styles.support} href="mailto:support@startingfinance.com?subject=Segnalazione%20Errore&body=Salve,%0Aho%20ricevuto%20un%20errore.%0A%0ADescrizione%20del%20problema:">Contatta il supporto</a>
        </div>
    </section>
</main>

export default Error
